import { useContext, useMemo } from 'react';
import { getClaimFeatureAccess } from 'shared/lib/authUtils';
import { PermissionContext } from './PermissionProvider';

/**
 * useFeatureAccess — reactive claim-feature access for the Permission Access
 * Layer (SA-1592 Phase A0).
 *
 * Reads `company` from the reactive PermissionContext projection and derives
 * the claim payment-method flags via `getClaimFeatureAccess`. This is the
 * reactive replacement for the non-reactive `useClaimFeatureAccess` in the
 * claim feature domain — the existing hook is left untouched in A0.
 *
 * @returns {{ isCashlessActive: boolean, isReimbursementActive: boolean,
 *   isQualityCheckerActive: boolean, isAnyClaimFeatureActive: boolean }}
 */
export const useFeatureAccess = () => {
  const { company } = useContext(PermissionContext);

  return useMemo(
    () => getClaimFeatureAccess(company?.company_features),
    [company]
  );
};
